__webpack_require__.p = "https://agency-react-staging.staffshift.com/";